import { useFlags } from "launchdarkly-react-client-sdk";

import { useUser } from "src/contexts/user-context";
import { usePersonalization } from "src/hooks/use-personalization";
import { useShouldSuppressFeatureAnnouncements } from "src/hooks/use-should-suppress-feature-announcements";
import { isHightouchStaffUser } from "src/utils/user";

export const useShouldShowAgentsTos = () => {
  const { user, workspace } = useUser();
  const { pretendImNotAHightouchAdmin } = useFlags();
  const shouldSuppressAnnouncements = useShouldSuppressFeatureAnnouncements();
  // Grandfather in users who accepted under the previous workspace-level ToS flow
  const isWorkspaceAccepted = Boolean(
    workspace?.personalization?.agents?.tosAccepted,
  );
  const { value: isDismissed, setLocal: setAgentsTosDismissed } =
    usePersonalization<boolean>({
      key: "agents.tos-modal-dismissed",
      initialValue: false,
      useWorkspace: false,
    });
  const { value: isGlobalDismissed, setLocal: setGlobalAgentsTosDismissed } =
    usePersonalization<boolean>({
      key: "agents.global-tos-modal-dismissed",
      initialValue: false,
      useWorkspace: false,
    });

  const isHightouchAdmin = isHightouchStaffUser(user?.admin_type, {
    pretendImNotAHightouchAdmin,
  });

  const shouldShowAgentsTos =
    !isDismissed &&
    // Grandfather in users who accepted under the previous workspace-level ToS flow
    !isWorkspaceAccepted &&
    // Don't show the modal to HT admins, this makes it hard to demo or investigate workspaces
    !isHightouchAdmin &&
    !shouldSuppressAnnouncements;

  const shouldShowGlobalAgentsTos = shouldShowAgentsTos && !isGlobalDismissed;

  return {
    isAgentsTosDismissed: isDismissed,
    isGlobalAgentsTosDismissed: isGlobalDismissed,
    shouldShowAgentsTos,
    shouldShowGlobalAgentsTos,
    setAgentsTosDismissed,
    setGlobalAgentsTosDismissed,
  };
};
